import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  postFormEditPersonalInformationStart,
  postFormEditPersonalInformationFailed,
} from "../redux/postFormEditPersonalInformation";

import { postUpdatePersonalInfoApi } from "core/http/service/personnelInformation";
import {
  bankInformationChangeDataSelector,
  basicInformationChangeDataSelector,
  educationInformationChangeDataSelector,
  maritalInformationChangeDataSelector,
  residenceInformationDataChangeSelector,
} from "../redux/selector";
import { filterEmptyProperties } from "helper/utils";
import { getBasicInformationStart } from "../redux/getBasicInformation";
import { getBankInformationStart } from "../redux/getBankInformation";
import { getResidenceInformationStart } from "../redux/getResidenceInformation";
import { getMaritalInformationStart } from "../redux/getMaritalInformation";
import { getLanguageInformationStart } from "../redux/getLanguageInformation";
import { getEducationInformationStart } from "../redux/getEducationInformation";
import { getCheckEditableStart } from "../redux/getPermissionEdit";
import { resetControl } from "../redux/control";
import { toast } from "react-toastify";
import { getCertificationInformationStart } from "../redux/getCertificationInformation";
import { getCertificationProfessionalStart } from "../redux/getCertificationProfessional";

function* getSignatureWork() {
  const bankInformation = yield select(bankInformationChangeDataSelector);
  const relativeInformation = yield select(
    maritalInformationChangeDataSelector
  );
  const educationInformation = yield select(
    educationInformationChangeDataSelector
  );
  const personalInformation = yield select(basicInformationChangeDataSelector);
  const residenceInformation = yield select(
    residenceInformationDataChangeSelector
  );

  const data = {
    academics: (educationInformation?.education ?? [])?.map((it) => ({
      ...it,
      graduationYear: it.graduationYear
        ? it.graduationYear.format("YYYY")
        : null,
    })),
    address: residenceInformation ?? {},
    bankInfo: bankInformation ?? {},
    certificates: [
      ...(educationInformation?.certificates ?? []),
      ...(educationInformation?.certificateOthers ?? []),
    ],
    personalInfo: personalInformation ?? {},
    relative: relativeInformation ?? {},
    languages: educationInformation?.languages ?? [],
    professionalCertificates:
      educationInformation?.professionalCertificates ?? [],
  };
  const payload = filterEmptyProperties(data);

  try {
    yield call(postUpdatePersonalInfoApi, {
      screenCode: "IP_002",
      body: payload,
    });

    toast.success(
      "Gửi yêu cầu chỉnh sửa thành công. Bạn có thể xem lại phần yêu cầu chỉnh sửa tại “Lịch sử chỉnh sửa”"
    );

    yield put({
      type: resetControl.type,
    });

    yield put({
      type: getCheckEditableStart.type,
    });

    yield put({
      type: getBasicInformationStart.type,
    });

    yield put({
      type: getBankInformationStart.type,
    });

    yield put({
      type: getResidenceInformationStart.type,
    });

    yield put({
      type: getMaritalInformationStart.type,
    });

    yield put({
      type: getLanguageInformationStart.type,
    });

    yield put({
      type: getEducationInformationStart.type,
    });

    yield put({
      type: getCertificationInformationStart.type,
    });
    yield put({
      type: getCertificationProfessionalStart.type,
    });
  } catch (error: any) {
    if (error?.response?.data?.code === "9999") {
      toast.error("Có lỗi xảy ra trong quá trình gửi yêu cầu chỉnh sửa");
    } else {
      toast.error(
        error?.response?.data?.message ||
          "Có lỗi xảy ra trong quá trình gửi yêu cầu chỉnh sửa"
      );
    }

    yield put({
      type: postFormEditPersonalInformationFailed.type,
    });
  }
}

function* watchPostForm() {
  yield takeLatest(postFormEditPersonalInformationStart.type, getSignatureWork);
}

export default function* postFormEditPersonalInformationSaga() {
  yield all([watchPostForm()]);
}
